// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-tasks-columns-dropdown{width:200px;float:right}`, "",{"version":3,"sources":["webpack://./client/Applications/DataGrids/Grids/Tasks/TasksTable.scss"],"names":[],"mappings":"AAAA,6BACI,WAAA,CACA,WAAA","sourcesContent":[".edit-tasks-columns-dropdown {\n    width: 200px;\n    float: right;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
